<kendo-gridlayout class="actions-grid" [gap]="12">
  <ng-content />
</kendo-gridlayout>
